export var getLineNumWidth = function getLineNumWidth(numLines) {
  return !numLines ? '1ch' : "".concat(numLines.toFixed(0).length, "ch");
};